<template>
  <div id="app">
    <template v-if="isInsideIframe">
      <IntelligenceBankContainer/>
    </template>
    <template v-else>
      <Info/>
    </template>
  </div>
</template>

<script>
import IntelligenceBankContainer from './components/IntelligenceBankContainer.vue'
import Info from './components/Info.vue'

export default {
  name: 'App',
  components: {
    IntelligenceBankContainer,
    Info
  },
  data() {
    return {
      isInsideIframe: window.self !== window.top
    }
  },
  methods: {},
  mounted() {

  }
}
</script>

<style>
@import url('~@salesforce-ux/design-system/assets/styles/salesforce-lightning-design-system.min.css');

body {
  margin: 0;
}
</style>
